import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Breadcrumb from "../../components/Breadcrumb";
import BookGridMain from "./BookGridMain";
import ScrollToTop from "../../components/ScrollTop";

const Book = () => {
  return (
    <body className="courses-grid-page">
      <Header parentMenu="course" menuCategoryEnable="enable" />

      <div className="react-wrapper">
        <div className="react-wrapper-inner">
          <Breadcrumb pageTitle="French Book Store" />

          <BookGridMain />

          {/* scrolltop-start */}
          <ScrollToTop />
          {/* scrolltop-end */}
        </div>
      </div>

      <Footer />
    </body>
  );
};

export default Book;
